import { tracked } from '@glimmer/tracking';

export default class IndividualStageInput {
  stageLetter;
  @tracked implementation; // string (e.g: sallenKey or FilterConstants.implementationTypes.sallenKey)
  @tracked componentSizing; // ./slider
  @tracked gainRatio; // .slider
  @tracked opAmp; // string (e.g AD9914 or FilterConstants.idealOpAmp when using the ideal one),
  implementationSelection;

  constructor(args) {
    if (args) {
      this.stageLetter = args.stageLetter ?? null;
      this.implementation = args.implementation ?? null;
      this.componentSizing = args.componentSizing ?? null;
      this.gainRatio = args.gainRatio ?? null;
      this.opAmp = args.opAmp ?? null;
      this.implementationSelection = args.implementationSelection ?? null;
    }
  }
}
